/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Thu Dec 20 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import popupTemplate from '../views/edit-subject-package.html';

class SubjectSetupController {
    constructor($scope, $rootScope, authService, localStorageService, $state, $mdDialog, $mdMedia) {
        'ngInject';
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Subject Setup"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        let self = this
        let schoolId = localStorageService.get('school_id')

        let requestObj = {
            args: {
                school_id: schoolId
            }
        }

        $scope.getList = function () {
            authService.callAPI("/v0/utilites/subject/init", "POST", requestObj, function (response) {
                try {
                    console.log(response.result.data.details.response);
                    self.packages = response.result.data.details.response
                } catch (e) {
                    self.packages = []
                }
                $scope.$apply()
            })
        }

        $scope.getList()

        self.editSubjectPackage = function (packId) {
            let packageDetails = _.find(self.packages, function (o) { return o._id == packId; })
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'data', 'localStorageService', 'authService', 'parentScope', UpdatePackageController],
                controllerAs: 'updatePackageCtrl',
                locals: {
                    "data": packageDetails,
                    parentScope: $scope
                },
                template: popupTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: useFullScreen
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }

        self.removeSubPackage = (subjectPack) => {
            let packId = subjectPack._id

            let requestObj = {
                args: {
                    packId: packId,
                    school_id: schoolId
                }
            }
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete ' + subjectPack.name + '?')
                .textContent('')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                authService.callAPI("/v0/utilites/subject/remove-package", "POST", requestObj, function (response) {
                    if (response && response.result) {
                        $scope.getList()
                        toastr.success('Successfully removed!');
                    } else {
                        try {
                            console.log(response.error);
                            if (response.error.status.code == 400) {
                                toastr.error(response.error.error.error)
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                })
            });
        }

        self.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        this.$onDestroy = () => {

        }
    }
}

class UpdatePackageController {
    constructor($scope, $mdDialog, data, localStorageService, authService, parentScope) {

        let self = this;

        $scope.packData = {}
        $scope.packData.list = [{
            "name": ""
        }]

        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
            parentScope.getList()
        };
        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };
        if (data) {
            $scope.isEdit = true
            $scope.packData = data
            $scope.oldPackName = $scope.packData.name
        }

        $scope.updateSubPckage = function () {
            $scope.errors = {}
            if ($scope.packData["deletes"]) {
                if ($scope.packData.deletes.length > 0) {
                    let names = _.pluck($scope.packData.deletes, 'name')
                    var confirm = $mdDialog.confirm()
                        .title('Are you sure to delete the ' + names + '?')
                        .textContent('')
                        .targetEvent(event)
                        .ok('Yes')
                        .cancel('No');
                    $mdDialog.show(confirm).then(function () {
                        updateSubjetPackage($scope.packData)
                    },function () {
                        parentScope.getList()
                    })

                }
            } else {
                validatePackdata($scope.packData)
            }
        };
        function validatePackdata(packData) {
            var undefinedName = 0
            _.each(packData.list, function (listObj) {
                if (listObj.name == "" || listObj.name == null || listObj.name == undefined)
                    undefinedName = 1
            })
            if (undefinedName == 0)
                updateSubjetPackage(packData)
            else
                toastr.error("Please enter subject name")
        }

        function updateSubjetPackage(packData) {
            let requestObj = {
                args: {
                    pack_data: packData,
                    school_id: localStorageService.get('school_id')
                }
            }

            authService.callAPI("/v0/utilites/subject/update-package", "POST", requestObj, function (response) {
                if (response && response.result) {
                    $scope.isEdit = false
                    parentScope.getList()
                    toastr.success('Successfully saved!');
                    $scope.cancel()
                } else {
                    try {
                        console.log(response.error);
                        if (response.error.status.code == 400) {
                            toastr.error(response.error.error.message)
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                }
            })
        }

        $scope.addSubject = function () {
            if (!$scope.packData) {
                $scope.packData = {}
                $scope.packData.list = []
            }

            if (!$scope.packData.list) {
                $scope.packData.list = []
            }

            $scope.packData.list.push({
                name: ""
            });
        };

        $scope.removeSubject = function (subjectDet, position) {
            if (!$scope.packData.deletes) {
                $scope.packData.deletes = []
            }
            if (subjectDet._id && subjectDet.name) {
                let subObj = {}
                subObj._id = subjectDet._id
                subObj.name = subjectDet.name
                $scope.packData.deletes.push(subObj)
            }
            if(!subjectDet.name){
                $scope.packData.list.splice(position, 1)
            }
            $scope.packData.list = _.without($scope.packData.list, _.findWhere($scope.packData.list, {
                _id: subjectDet._id
            }));
        };

    }
}

export default SubjectSetupController;



// WEBPACK FOOTER //
// ./src/app/utilities/subjectSetup/controllers/subjectSetupController.js